import { useSyncExternalStore } from 'react';

// Mobile-breakpoint hook. Returns true when the viewport is at or
// below 768px (iPad portrait and below). Backed by matchMedia so the
// listener fires on rotate / window resize without us re-rendering on
// every resize tick. SSR-safe: defaults to false when window is
// undefined.
//
// Usage:
//   const isMobile = useIsMobile();
//   return isMobile ? <MobileLayout /> : <DesktopLayout />;
//
// Pass a custom breakpoint to override:
//   const isPhone = useIsMobile(480);
export function useIsMobile(breakpoint = 768) {
  const query = `(max-width: ${breakpoint}px)`;

  return useSyncExternalStore(
    (onStoreChange) => {
      if (typeof window === 'undefined' || !window.matchMedia) return () => {};
      const mq = window.matchMedia(query);
      // Safari < 14 uses the legacy addListener API; modern browsers
      // expose addEventListener. Try the modern API first, fall back.
      if (mq.addEventListener) {
        mq.addEventListener('change', onStoreChange);
        return () => mq.removeEventListener('change', onStoreChange);
      }
      mq.addListener(onStoreChange);
      return () => mq.removeListener(onStoreChange);
    },
    () => {
      if (typeof window === 'undefined' || !window.matchMedia) return false;
      return window.matchMedia(query).matches;
    },
    () => false,
  );
}

export default useIsMobile;
